<template>
    <div class="table-container-compact">
        <table class="table-compact">
            <thead>
                <tr>
                    <th style="text-align: center; width: 90px">유형</th>
                    <th style="text-align: center">제목</th>
                    <th style="text-align: center; width: 70px">심각도</th>
                    <th style="text-align: center; min-width: 110px">발송일시</th>
                    <th style="text-align: center; width: 60px">읽음</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="loading">
                    <td colspan="6" class="text-center"><i class="fas fa-spinner fa-spin"></i> 로딩 중...</td>
                </tr>
                <tr v-else-if="!notifications || notifications.length === 0">
                    <td colspan="6" class="text-center empty">조회된 알림이 없습니다</td>
                </tr>
                <tr
                    v-else
                    v-for="row in notifications"
                    :key="row.notificationIdx"
                    class="clickable-row"
                    :class="{ unread: !row.isRead }"
                    @click="$emit('row-click', row)"
                    tabindex="0"
                    @keydown.enter="$emit('row-click', row)"
                    @keydown.space.prevent="$emit('row-click', row)"
                >
                    <td style="text-align: center">
                        <span class="event-badge" :title="getEventLabel(row.eventType)">
                            {{ getEventLabel(row.eventType) }}
                        </span>
                    </td>
                    <td style="text-align: left" :title="row.title">{{ truncate(row.title, 50) }}</td>
                    <td style="text-align: center">
                        <span class="severity-badge" :class="'severity-' + (row.severity || 'low')">
                            {{ getSeverityLabel(row.severity) }}
                        </span>
                    </td>
                    <td style="text-align: center">{{ formatDate(row.sentDate || row.regDate) }}</td>
                    <td style="text-align: center">
                        <span v-if="row.isRead" class="read-status">읽음</span>
                        <span v-else class="read-status unread">안읽음</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import CarbonCodes from "@/submodules/carbon-plugin/codes";

export default {
    name: "NotificationTable",
    props: {
        notifications: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
    },
    methods: {
        getEventLabel(eventType) {
            const normalized = (eventType || "").toUpperCase().replace(/-/g, "_");
            return CarbonCodes.eventType.getLabel(normalized) || eventType || "-";
        },
        getSeverityLabel(severity) {
            return CarbonCodes.severity.getLabel(severity) || severity || "-";
        },
        truncate(str, len) {
            if (!str) return "-";
            return str.length <= len ? str : str.slice(0, len) + "…";
        },
        formatDate(val) {
            if (!val) return "-";
            const d = typeof val === "string" ? new Date(val) : val;
            if (isNaN(d.getTime())) return String(val);
            return d.toLocaleString("ko-KR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            });
        },
    },
};
</script>

<style scoped>
.table-compact tbody tr.unread {
    background: #f0fdf4;
}
.table-compact tbody tr.unread:hover {
    background: #dcfce7;
}
.clickable-row:focus {
    outline: 2px solid #52b788;
    outline-offset: -2px;
}
/* .text-center 는 전역 _carbon-tables.scss 적용 */
.empty {
    padding: 30px;
    color: #94a3b8;
}
.event-badge {
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
}
.severity-badge {
    font-size: 11px;
    font-weight: 500;
}
.severity-low {
    color: #22c55e;
}
.severity-medium {
    color: #eab308;
}
.severity-high {
    color: #f97316;
}
.severity-critical {
    color: #ef4444;
    font-weight: 600;
}
.read-status {
    font-size: 11px;
    color: #94a3b8;
}
.read-status.unread {
    color: #52b788;
    font-weight: 600;
}
</style>
